import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

interface OrderResponse {
    items: any[];
}

@Injectable({
    providedIn: 'root'
})

export class WabotClientLastOrderService {
    constructor(
        private http: HttpClient
    ) {}

    getOrderByUUID(uuid: string): Promise<OrderResponse | null> {
        if (!uuid) {
            return Promise.resolve(null);
        }

        const url = `https://product-suggestion.lambda.multipedidos.com.br/${uuid}.json`;

        return new Promise((resolve, reject) => {
            this.http.get<OrderResponse>(url).subscribe(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    if (error.status === 404) {
                        resolve(null);
                    } else {
                        console.error('Erro ao buscar pedido pelo UUID:', error);
                        reject(error);
                    }
                }
            );
        });
    }
}
